const pname = (name) => {
  if (name === '<unknown>') {
    return ''
  }
  return name
}

export default class {
  constructor (data) {
    this.parkeeName = data.parkeecalleridname
    this.parkeeNum = data.parkeecalleridnum
    if (!this.parkeeName && !this.parkeeNum) {
      throw new Error('Invalid parkee data')
    }
    this.parkerName = data.parkeeconnectedlinename
    this.parkerNum = data.parkeeconnectedlinenum
    if (!this.parkerName && !this.parkerNum) {
      throw new Error('Invalid parker data')
    }
    this.lot = data.parkinglot
    this.exten = data.parkeeexten
    this.space = data.parkingspace
    this.channel = data.parkeechannel
    if (!this.channel) throw new Error('Missing parking channel')
    this.uniqueid = data.parkeeuniqueid
    if (!this.uniqueid) throw new Error('Missing uniqueid')
    this.timeout = ~~data.parkingtimeout
    this.duration = ~~data.parkingduration
    this.started = new Date(Date.now() - (this.duration * 1000))
  }

  /**
   * @getters
   */
  get Exten () {
    if (this.exten.indexOf('PARKING_') < 0) {
      return this.exten
    }
    return this.exten.substr(8)
  }

  get Space () { return this.space }

  get ParkerNum () { return this.parkerNum }

  get ParkerName () { return pname(this.parkerName) }

  get ParkeeName () { return pname(this.parkeeName) }

  get ParkeeNum () { return this.parkeeNum }

  get isFree () { return false }

  /**
   * @public
   * Math parking AMI event data to this parking call
   * Returns true if matches parked call
   */
  match (data) {
    return this.channel === data.parkeechannel &&
      this.space === data.parkingspace
  }

  /**
   * @public
   * Swap channel value. When using attended x-fer to parking extension
   * Asterisk will send ParkedCallSwap event to update parked call channel
   * @param data AMI event ParkedCallSwap
   */
  swapChan (data) {
    if (this.lot === data.parkinglot && this.space === data.parkingspace) {
      this.channel = data.parkeechannel
      this.parkeeName = data.parkeecalleridname
      this.parkeeNum = data.parkeecalleridnum
      this.parkerName = data.parkeeconnectedlinename
      this.parkerNum = data.parkeeconnectedlinenum
    }
  }
}
